<template>
  <g-page-wrapper v-if="showUserInfo">
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_user_CustomerInfo.path.2')" :paths="[{
        path: '/user/list',
        name: this.$t('pages_user_CustomerInfo.path.1')
      }, {
        name: this.$t('pages_user_CustomerInfo.path.2')
      }]"></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-container-resizing">
          <div class="-width-100 -tile-container -wrapper-half nowrap- -px-5 white-space-normal">
            <div class="-bg-white">
              <div class="-wrapper-tile">
                <div class="-header">
                  <p class="-h2">{{$t('pages_user_CustomerInfo.company_info')}}</p>
                  <g-button v-if="this.userDetail.auth == 'AM'" variant="primary" id="customer-info-change-customer" size="small"
                            @click="onClickChangeCustomer">
                    <g-icon class="-color-white" name="edit">edit</g-icon>
                    <span>{{$t('pages_user_UserCreateAccount.editCustomer')}}</span>
                  </g-button>
                </div>
              </div>
              <div class="-tile-container">
                <div class="-div-table -px-5 -pb-5">
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('common.company_name')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1 -font-size-14" id="customer-info-customerName">
                          {{userDetail.customerName}}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('common.company_no')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="customer-info-customerRegistorNo">
                          {{userDetail.customerRegistorNo}}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('common.post_no')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="customer-info-customer-pos">
                          {{userDetail.pos}}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_user_CustomerInfo.company.2')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="customer-info-customer-city">
                          {{userDetail.city}}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header -pl-4">
                      <h5 class="-font-size-12 txt-center">{{$t('pages_user_CustomerInfo.company.3')}}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-paragraph -ml-1" id="customer-info-customer-locd">
                          {{userDetail.locD}}
                        </span>
                      </p>
                    </div>
                  </div>
                    <div v-if=" 'AM'===userDetail.auth" class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('pages_user_UserCreateAccountSelectManager.constract.add')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <g-button variant="secondary" @click="onClickChangeContract">
                            <span>{{$t('pages_user_UserCreateAccountSelectManager.constract.add')}}</span>
                          </g-button>
                          <g-input-text class="-width-100 "  v-show="false" disabled :value="managerName"></g-input-text>
                        </p>
                      </div>
                    </div>


                  <!-- -->

                </div>
              </div>

              <!-- -->
              <div v-if=" 'AM'===userDetail.auth">
                <div class="-tile-container">
                  <div class="-div-table -px-5 -pb-5">
                    <table class="-table" id="am">
                      <caption/>
                      <thead>
                      <tr>
                        <th scope="col" class="-position-relative">
                          <div class="-wrapper-v-center">
                            <span>{{ $t('pages_contract_ContractInfo.column.headerName.id') }}</span>

                          </div>
                        </th>
                        <th scope="col" >
                          <div class="-wrapper-v-center">
                            <span>{{ $t('pages_contract_ContractInfo.column.headerName.contractName') }}</span>

                          </div>
                        </th>
                        <th scope="col" >
                          <div class="-wrapper-v-center">
                            <span>{{ $t('pages_notice_info.delete') }}</span>
                          </div>
                        </th>
                      </tr>
                      </thead>
                      <tbody>

                      <template  v-for="item in contractList">

                        <tr :key="item.contractCode">
                          <td>{{item.contractCode}}</td>
                          <td style="width: 60%">{{item.contractName}}</td>
                          <td>
                            <g-button variant="primary" size="small" :id="'customer-contract-del-click_'+item.contractCode" style="padding: 0px 8px"
                                      @click="onClickDeleteContract(item.contractCode)">
                              <span>{{$t('pages_notice_info.delete')}}</span>
                            </g-button>
                          </td>
                        </tr>
                      </template>

                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
              <!-- -->
            </div>
            <div class="-ml-5">
              <div class="-bg-white">
                <div class="-wrapper-tile">
                  <div class="-header -pr-2">
                    <p class="-h2">{{$t('common.user_info')}}</p>
                    <div>
                      <g-button v-if="this.userDetail.auth != 'AM' && this.userDetail.userEmail != this.userInfo.userEmail " variant="primary" id="customer-info-changeinfo" size="small"
                                @click="onClickChangeInfo">
                        <g-icon class="-color-white" name="edit">edit</g-icon>
                        <span>{{$t('pages_user_UserCreateAccount.editAuth')}}</span>
                      </g-button>

                      <g-dropdown-wrap
                        id="customer-info-isbespinadmin"
                        v-if="isBespinAdmin && this.userDetail.userEmail != this.userInfo.userEmail"
                        style="display: inline-flex;"
                        class="-mr-2"
                        :openItem.sync="openDrondown">
                        <g-button
                          id="customer-info-more"
                          variant="borderless"
                          icon-only
                          size="small"
                          class="-mr-0 -px-1"
                          @click="onClickDropdown"
                          style="padding: 0px; justify-content: center;">
                          <g-icon name="more_vert">more_vert</g-icon>
                        </g-button>
                        <g-dropdown-item-wrap direction="down-right" wrap-style="top: 130%;">
                          <g-button
                            id="customer-info-useyes"
                            v-if="userDetail.useYn === 'Y'"
                            variant="borderless"
                            class="-width-100 -mx-0 start- -px-2"
                            @click="onClickUserStatus('N')">
                            <g-icon tag="span" name="block" size="large"/>
                            <span>
                              {{$t('pages_user_CustomerInfo.user-dropdown.deactive')}}
                            </span>
                          </g-button>
                          <g-button
                            id="customer-info-useno"
                            v-if="userDetail.useYn === 'N'"
                            variant="borderless"
                            class="-width-100 -mx-0 start- -px-2"
                            @click="onClickUserStatus('Y')">
                            <g-icon tag="span" name="how_to_reg" size="large"/>
                            <span>
                              {{$t('pages_user_CustomerInfo.user-dropdown.active')}}
                            </span>
                          </g-button>
                          <g-button
                            id="customer-info-delete"
                            variant="borderless"
                            class="-width-100 -mx-0 start- -px-2"
                            @click="onClickUserDelete('D')">
                            <g-icon tag="span" name="delete" size="large"/>
                            <span>
                              {{$t('pages_user_CustomerInfo.user-dropdown.remove')}}
                            </span>
                          </g-button>
                        </g-dropdown-item-wrap>
                      </g-dropdown-wrap>
                    </div>
                  </div>
                </div>
                <div class="-tile-container">
                  <div class="-div-table -px-5 -pb-5">
                    <div class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('common.user_name')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1 -font-size-14"  id="customer-info-userName">
                            {{userDetail.userName}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('pages_user_CustomerInfo.info.2')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1" id="customer-info-customerDeptName">
                            {{userDetail.customerDeptName}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('common.email')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1" id="customer-info-userEmail">
                            {{userDetail.userEmail}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('common.phone')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1" id="customer-info-userTelNo">
                            {{userDetail.userTelNo}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="-row">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('pages_user_CustomerInfo.info.3')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1" id="customer-info-authname">
                            {{groupInfoById(userDetail.auth).name}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="-row" v-if="isUserDetailMiddleManager">
                      <div class="-row-header -pl-4">
                        <h5 class="-font-size-12 txt-center">{{$t('common.middle_group')}}</h5>
                      </div>
                      <div class="-row-contents">
                        <p class="-wrapper-v-center">
                          <span class="-paragraph -ml-1" id="customer-info-leadercodename">
                            {{getMiddleManagerInfo(userDetail.leader).codeName}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="-row -px-5 -pb-5">
                      <ag-grid-vue id="company-popup-ag-grid-vue"
                        style="height: 150px;border-top:none; border-left:none; border-right:none"
                        class="ag-theme-balham -border"
                        row-height="30"
                        header-height="30"
                        :defaultColDef="defaultColDef"
                        :columnDefs="columnDefs"
                        :gridOptions="gridOptions"
                        :rowData="groups"
                        :overlayLoadingTemplate="overlayLoadingTemplate"
                        :loadingOverlayComponent="loadingOverlayComponent"
                        :loadingOverlayComponentParams="loadingOverlayComponentParams"
                        :overlayNoRowsTemplate="overlayNoRowsTemplate"
                        :noRowsOverlayComponent="noRowsOverlayComponent"
                        :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
                        :frameworkComponents="frameworkComponents"
                        :modules="modules"
                        :pagination="false"
                        :suppressPaginationPanel="true"
                        :suppressScrollOnNewData="true"
                        @grid-ready="onGridReady"
                      >
                      </ag-grid-vue>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import CodeInfo from '../../code/CodeInfo'
import {AUTH_GROUP, MARKET_SERVICE_CODE} from "@/constants/constants";
import ConfirmPopup from '../components/ConfirmPopup'
import CustomerContractPopup from "@/pages/components/CustomerConstractPopup.vue";
import CodeUpdate from '@/code/CodeUpdate'
import UserInfoChange from './components/UserInfoChange'
import CustomerListPopup from "./components/CustomerListPopup.vue"
import {AgGridVue} from 'ag-grid-vue';
import AgGridMixin from '../mixin/AgGrid.mixin'

export default {
  inheritAttrs: false,
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  data() {
    return {
      showUserInfo: false,
      openDrondown: false,
      selectedManager: {},
      columnDefs: [],
      defaultColDef: {},
      gridOptions: null,
      thisSearchName: '',
      groups: [],
    }
  },
  filters: {
    toDateTime (value) {
      return moment(value).format('YYYY/MM/DD HH:mm:ss')
    }
  },
  computed: {
    ...mapGetters('customer', [
      'groupInfoById',
      'groupList'
    ]),
    ...mapGetters('code', ['snsList', 'middleGroupList']),
    ...mapGetters('user', [
      'userInfo',
      'userDetail',
      'codeChangeUserStatus',
      'changeUserStatus',
      'userErrorMessage',
      'codeUserDetail',
      'contractList'
    ]),
    isBespinAdmin () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    },
    isUserDetailMiddleManager () {
      return this.userDetail.auth === AUTH_GROUP.BespinMiddleManager
    },
    managerName () {

      this.selectedManager =this.userDetail.customerCode
      setTimeout(function () {

        this.getInit()
      }.bind(this), 20);

      return this.selectedManager
    },
  },
  methods: {
    ...mapActions('user', [
      'getUserDetail',
      'updateUserStatus',
      'getCustomerContract',
      'deleteCustomerContractList',
      'updateUserCustomer',
      'getUserGroup'
    ]),
    onClickChangePassword (e) {
      this.$popupManager.open(CustomerInfoChangePassword)
    },
    onClickChangeInfo (e) {
      this.$popupManager.open(UserInfoChange)
    },
    getMiddleManagerInfo (codeId) {
      return this.middleGroupList.find(item => item.codeId === codeId) || {}
    },
    onClickDropdown () {
      this.openDrondown = !this.openDrondown
    },
    onClickUserStatus (status) {
      this.openDrondown = !this.openDrondown
      this.updateUserStatus({
        userId: this.userDetail.userId,
        useYn: status
      })
    },
    onClickUserDelete () {
      this.$popupManager.open(ConfirmPopup, {
        text: this.$t('pages_user_CustomerInfo.confirm_text'),
        onConfirm: () => {
          this.onClickUserStatus('D')
      }})
    },
    onClickChangeContract () {

      const selectedManagerId =this.userDetail.customerCode+","+this.userDetail.customerDeptCode+","+this.userDetail.userEmail+","+this.userDetail.companyCode
      this.$popupManager.open(CustomerContractPopup, {
        onSend: (selectedValue) => {
          this.selectedManager = selectedValue
        },
        selectedManagerId
      })
    },
    onClickDeleteContract(val){
      this.$popupManager.open(ConfirmPopup, {
        text: this.$t('pages_user_CustomerInfo.contract.delete.confirmt'),
        onConfirm: () => {
          let param = {}

          param.contractCode = val
          param.customerCode = this.userDetail.customerCode
          param.customerDeptCode = this.userDetail.customerDeptCode
          param.companyCode = this.userDetail.companyCode
          param.userEmail = this.userDetail.userEmail

          this.deleteCustomerContractList(param)
          this.$showToast(this.$t('pages_user_CustomerInfo.contract.delete'))

          setTimeout(function () {
            this.getInit()
          }.bind(this), 100);
        }})


    },
    onClickChangeCustomer () {
      this.$popupManager.open(CustomerListPopup, {
        onSend: (selectedValue) => {

          this.$popupManager.open(ConfirmPopup, {
          text: this.$t('pages_user_UserCreateAccount.changeCustomer'),
          onConfirm: async () => {

            await this.updateUserCustomer({userEmail: this.userDetail.userEmail, customerCode: selectedValue.customerCode, customerDeptCode: selectedValue.customerDeptCode.replace(selectedValue.customerCode + "|", "")})
            this.$showToast(this.$t('pages_user_UserCreateAccount.haschangedCustomer'))

            this.userDetail.customerCode = selectedValue.customerCode
            this.userDetail.customerName = selectedValue.customerName
            this.userDetail.deptCode = selectedValue.customerDeptCode.replace(selectedValue.customerCode + "|", "")
            this.userDetail.deptName = selectedValue.deptName
            this.userDetail.locD = selectedValue.locD
            this.userDetail.pos = selectedValue.pos
            this.userDetail.customerRegisNo = selectedValue.customerRegistorNo
            this.userDetail.city = selectedValue.city
            setTimeout(() => {
              this.$router.go(this.$router.currentRoute)
            }, 1500)
          }
        }

        )


        }
      })
    },
    getInit(){
      let param = {}

      param.companyCode =  this.userDetail.companyCode
      param.userEmail =  this.userDetail.userEmail
      param.customerCode =  this.userDetail.customerCode
      param.customerDeptCode =  this.userDetail.customerDeptCode
    //  setTimeout(function () {
        this.getCustomerContract(param)
    //  }.bind(this), 1500);


    },
    isLastNameFirst(){
      return this.locale != 'en';
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    setColumn () {
      this.columnDefs = [
        {
          headerName: this.$t('pages_user_UserCreateAccount.userGroups'),
          field: "groupName",
          width: 40,
          sortable: true,
          unSortIcon: true,
          getQuickFilterText: params => {
            return params.data.groupName
          },
          cellRenderer: params => {
            return params.data.groupName.concat('(',params.data.companyName,')')
          }
        }
      ];
      this.fitGrid()
    },
    onGridReady(params) {
      this.setGridParams(params)
      this.setGridParams(params)
      this.fitGrid()
    },
  },
  beforeMount() {
    this.getInit()
  },
  watch: {
    codeChangeUserStatus (value) {
      if (value === CodeUpdate.SUCCESS) {
        this.$showToast(this.$t(`pages_user_CustomerInfo.change_status_${this.changeUserStatus}`))
        if (this.changeUserStatus === 'D') {
          this.$router.push('/user/list')
        }
      } else if (value === CodeUpdate.ERROR) {
        this.$showToast(this.$t('user.error'))
      }
    },
    codeUserDetail () {
      const { auth, customerCode, customerDeptCode} = this.userInfo
      if (this.codeUserDetail === CodeInfo.SUCCESS) {
        if (auth === AUTH_GROUP.AccountManager) {
          if (customerCode !== this.userDetail.customerCode || customerDeptCode !== this.userDetail.customerDeptCode) {
            this.$showToast(this.$t('common.no_authorization'))
            this.$router.push('/user/list')
            return
          }
        }
        this.showUserInfo = true
      } else if (this.codeUserDetail === CodeInfo.EXCEPTION) {
        this.$showToast(this.$t('user.error'))
        this.$router.push('/user/list')
      }
    }
  },
  mounted () {
    const { userid: userId } = this.$route.query
    if (this.userInfo.auth === AUTH_GROUP.BespinSales) {
      this.$showToast(this.$t('common.no_authorization'))
      this.$router.push('/user/list')
      return
    }

    // BP, PB 두개 권한에 대해서 임시로 접근 하지 못하도록 하였음 //
    if (this.userInfo.auth === AUTH_GROUP.BespinProductManager || this.userInfo.auth === AUTH_GROUP.BespinBilling) {
      this.$showToast(this.$t('common.no_authorization'))
      this.$router.push('/user/list')
      return
    }

    if (this.userInfo.auth === AUTH_GROUP.BespinMiddleManager) {
      this.$showToast(this.$t('common.no_authorization'))
      this.$router.push('/user/list')
      return
    }
    var that = this;
    this.getUserDetail({
      userId
    }).then(function(){
      that.getUserGroup({
      serviceCode: MARKET_SERVICE_CODE,
      siteCode: that.userInfo.siteCode,
      userEmail: that.userDetail.userEmail
      }).then(function(data){
        that.groups = data.items
      })
    })
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/user/UserInfo.vue